import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter as createReactRouter } from '@tanstack/react-router';
import { ThemeProvider } from 'next-themes';
import { routeTree } from './routeTree.gen';
import { Loader } from './components/Loader';

export const queryClient = new QueryClient();

export function createRouter() {
  return createReactRouter({
    routeTree,
    defaultNotFoundComponent: () => <>Not Found</>,
    defaultPendingComponent: () => (
      <div className="fixed inset-0 flex items-center justify-center">
        <Loader />
      </div>
    ),
    defaultPreload: 'intent',
    context: { queryClient },
    defaultPendingMs: 0,
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    Wrap: ({ children }) => (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider attribute="class" defaultTheme="dark">
          {children}
        </ThemeProvider>
      </QueryClientProvider>
    ),
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
